import styled from 'styled-components';

import { InformationBoxTheme, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Button } from '../button/button.component';
import { Image } from '../image/image.component';
import { Markdown } from '../markdown/markdown.component';

import { AvatarContainerProps, InformationBoxContainerProps } from './informationBox.types';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;
`;

export const Wrapper: StyledComponent<'div'> = styled.div`
  max-width: 100%;
  display: flex;
  align-items: center;
`;

export const InformationBoxContainer: StyledComponent<'div', InformationBoxContainerProps> = styled.div<InformationBoxContainerProps>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: ${({ $theme }: InformationBoxContainerProps): string => $theme === InformationBoxTheme.WithOutline ? '17px 16px' : '0'};
  border: ${(
    { $theme }: InformationBoxContainerProps
  ): string => $theme === InformationBoxTheme.WithOutline ? `1px solid ${Color.Gray300}` : 'none'};
`;

export const InformationDetails: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
`;

export const AvatarContainer: StyledComponent<'div', AvatarContainerProps> = styled.div<AvatarContainerProps>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ $withCustomIcon }: AvatarContainerProps): string => $withCustomIcon ? Color.Error500 : Color.Gray200};
  margin-right: 12px;
  flex-shrink: 0;
`;

export const AvatarImg: StyledComponent<typeof Image> = styled(Image)`
  object-fit: cover;
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const NamesContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
`;

export const Name: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 14px;
  line-height: 18px;
`;

export const SubName: StyledComponent<typeof Markdown> = styled(Markdown)`
  color: ${Color.Gray500};
  font-weight: ${FontWeight.Light};
  font-size: 12px;
  line-height: 18px;
`;

export const StyledButton: StyledComponent<typeof Button> = styled(Button)`
  margin-top: 12px;
`;

export const RemoveButton: StyledComponent<'button'> = styled.button`
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ArrowsContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  flex-direction: column;
  transition: .3s;
  margin: 0 16px;
`;

export const ArrowButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;

  & + & {
    margin-top: 12px;
  }
`;
